module.exports = __webpack_public_path__ + "static/media/proj4_img4.c293584d.jpg";